/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SearchToolCallsPayload,
  SearchToolCallsPayload$Outbound,
  SearchToolCallsPayload$outboundSchema,
} from "../components/searchtoolcallspayload.js";

export type SearchToolCallsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SearchToolCallsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SearchToolCallsSecurity = {
  option1?: SearchToolCallsSecurityOption1 | undefined;
  option2?: SearchToolCallsSecurityOption2 | undefined;
};

export type SearchToolCallsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  searchToolCallsPayload: SearchToolCallsPayload;
};

/** @internal */
export type SearchToolCallsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SearchToolCallsSecurityOption1$outboundSchema: z.ZodMiniType<
  SearchToolCallsSecurityOption1$Outbound,
  SearchToolCallsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function searchToolCallsSecurityOption1ToJSON(
  searchToolCallsSecurityOption1: SearchToolCallsSecurityOption1,
): string {
  return JSON.stringify(
    SearchToolCallsSecurityOption1$outboundSchema.parse(
      searchToolCallsSecurityOption1,
    ),
  );
}

/** @internal */
export type SearchToolCallsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SearchToolCallsSecurityOption2$outboundSchema: z.ZodMiniType<
  SearchToolCallsSecurityOption2$Outbound,
  SearchToolCallsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function searchToolCallsSecurityOption2ToJSON(
  searchToolCallsSecurityOption2: SearchToolCallsSecurityOption2,
): string {
  return JSON.stringify(
    SearchToolCallsSecurityOption2$outboundSchema.parse(
      searchToolCallsSecurityOption2,
    ),
  );
}

/** @internal */
export type SearchToolCallsSecurity$Outbound = {
  Option1?: SearchToolCallsSecurityOption1$Outbound | undefined;
  Option2?: SearchToolCallsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SearchToolCallsSecurity$outboundSchema: z.ZodMiniType<
  SearchToolCallsSecurity$Outbound,
  SearchToolCallsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SearchToolCallsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SearchToolCallsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function searchToolCallsSecurityToJSON(
  searchToolCallsSecurity: SearchToolCallsSecurity,
): string {
  return JSON.stringify(
    SearchToolCallsSecurity$outboundSchema.parse(searchToolCallsSecurity),
  );
}

/** @internal */
export type SearchToolCallsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SearchToolCallsPayload: SearchToolCallsPayload$Outbound;
};

/** @internal */
export const SearchToolCallsRequest$outboundSchema: z.ZodMiniType<
  SearchToolCallsRequest$Outbound,
  SearchToolCallsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    searchToolCallsPayload: SearchToolCallsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      searchToolCallsPayload: "SearchToolCallsPayload",
    });
  }),
);

export function searchToolCallsRequestToJSON(
  searchToolCallsRequest: SearchToolCallsRequest,
): string {
  return JSON.stringify(
    SearchToolCallsRequest$outboundSchema.parse(searchToolCallsRequest),
  );
}
